export default __webpack_public_path__ + "static/media/640_business02-it-mobile.0d0d66dc.png";